import api from "../configurations/http-common"

export const priceStrategyList = async () => {
  return api.securedAxios().get("web/price_strategies")
}

export const getSubscriptionByClientId = async () => {
  return api.securedAxios().get("web/client/subscription/client");
}

export const createSubscription = async (payload) => {
  return api.securedAxios().post("web/client/subscription", payload);
}

export const getAllSubscription = async (request,formValues) => {
  let query = "";
  if (request.pageNumber !== null || request.pageNumber !== "") {
    query += "?pageNumber=" + request.pageNumber;
  }
  if (request.pageSize !== null || request.pageSize !== "") {
    query += "&pageSize=" + request.pageSize;
  }
  return api.securedAxios().post("web/client/subscription/page" + query,formValues);
}
